import Vue from 'vue'

const oneHourInMS = 1000 * 60 * 60

function createId() {
  return 'f' + +(new Date())
}

export default {
  namespaced: true,
  state: {
    basket: getBasketFromLocalStorage()
  },
  mutations: {
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return
      Vue.set(state, key, value)
    },
    addProduct(state, product) {
      state.basket.push(product)
    },
    deleteProduct(state, specificId) {
      const index = state.basket.findIndex(item => item.specificId === specificId)
      Vue.delete(state.basket, index)
    },
    changeProductQuantity(state, {specificId, newQuantity}) {
      const index = state.basket.findIndex(item => item.specificId === specificId)
      Vue.set(state.basket[index], 'quantity', newQuantity)
    },

  },
  actions: {
    addProductToBasket({state, commit}, {type, product, quantity, variant, property, main_ingredients, additional_ingredients, comment}) {
      const basket = state.basket
      const productInBasketIndex = findProductIndexByProps(basket, product.id, main_ingredients, additional_ingredients, variant, property, comment)
      const productInBasket = basket[productInBasketIndex]

      if (productInBasketIndex < 0) {
        // IF PRODUCT NOT FOUND IN BASKET
        const newBasketItem = {
          type,
          product: JSON.parse(JSON.stringify(product)),
          quantity,
          variant,
          property,
          main_ingredients: JSON.parse(JSON.stringify(main_ingredients)),
          additional_ingredients: JSON.parse(JSON.stringify(additional_ingredients)),
          comment,
          specificId: createId()
        }

        commit('addProduct', newBasketItem)
      } else {
        // IF PRODUCT FOUND IN BASKET

        commit('changeProductQuantity', {
          specificId: productInBasket.specificId,
          newQuantity: productInBasket.quantity + quantity
        })
      }
    },
    clearBasket({dispatch}) {
      removeBasketFromLocalStorage()
      dispatch('loadBasket')
    },
    subscribe({state}) {
      this.subscribe((mutation) => {
        if (mutation.type.startsWith('basket/')) {
          setBasketToLocalStorage(state.basket)
        }
      })
    },
    loadBasket({commit}) {
      commit('setProperty', ['basket', getBasketFromLocalStorage()])
    }
  }
}

function findProductIndexByProps(products, productId, main_ingredients, additional_ingredients, variant, property, comment) {


  return products.findIndex(item => {
    if (
      item.product.id !== productId
      || item.variant.size !== variant.size
      || (item.property && item.property.id) !== (property && property.id)
      || item.comment !== comment
    ) {
      return false
    }

    return isSameIngredients(main_ingredients, item.main_ingredients) && isSameIngredients(additional_ingredients, item.additional_ingredients)
  })
}

function isSameIngredients(ingredients, ingredients2) {
  if (!ingredients) ingredients = []
  if (!ingredients2) ingredients2 = []
  ingredients = Object.values(ingredients)
  ingredients2 = Object.values(ingredients2)

  if (ingredients.length !== ingredients2.length) return false

  return !ingredients.find(item => {
    const id = item.ingredient.id
    const quantity = item.quantity

    return !ingredients2.find(item2 => {
      return item2.ingredient.id === id && item2.quantity === quantity
    })
  })
}

// LOCAL STORAGE

function setBasketToLocalStorage(products) {
  if (!Array.isArray(products)) return

  let restaurant_id = window.localStorage.getItem('active_restaurant_id') || null
  if (!restaurant_id) return
  let result = window.localStorage.getItem('basket') || null

  result = JSON.parse(result) || {}

  if (!products.length) {
    delete result[restaurant_id]
  } else {
    result[restaurant_id] = {
      created: new Date(),
      products
    }
  }

  if (Object.keys(result).length) {
    window.localStorage.setItem('basket', JSON.stringify(result))
  } else {
    window.localStorage.removeItem('basket')
  }
}

function getBasketFromLocalStorage() {
  let result = window.localStorage.getItem('basket') || null
  let restaurant_id = window.localStorage.getItem('active_restaurant_id') || null

  if (!result && !restaurant_id) return []

  result = JSON.parse(result) || {}

  let resultForId = result[restaurant_id]

  if (!resultForId) return []

  const createdDate = new Date(resultForId.created)
  const minDate = new Date() - oneHourInMS * 12


  return createdDate > minDate ? resultForId.products : []
}

function removeBasketFromLocalStorage() {
  let restaurant_id = window.localStorage.getItem('active_restaurant_id') || null
  let result = window.localStorage.getItem('basket') || null
  if (!result && !restaurant_id) return

  result = JSON.parse(result)
  delete result[restaurant_id]

  window.localStorage.setItem('basket', JSON.stringify(result))
}
